var sgMap;

var SgCreateMapStoreLocation = (function () {
    return {
        init: function () {
            var mapEl = document.getElementById('sg-map');
            if (!mapEl) return;

            var token = mapEl.dataset.token || '';
            var lat   = parseFloat(mapEl.dataset.lat)  || 45.4642;
            var lng   = parseFloat(mapEl.dataset.lng)  || 9.1900;
            var zoom  = parseFloat(mapEl.dataset.zoom) || 6;

            if (!token) {
                mapEl.innerHTML = '<p style="padding:20px;color:red;">Mapbox Access Token mancante. Impostalo nelle opzioni della sezione nel theme editor.</p>';
                return;
            }

            mapboxgl.accessToken = token;
            sgMap = new mapboxgl.Map({
                container: 'sg-map',
                style: 'mapbox://styles/mapbox/streets-v12',
                center: [lng, lat],
                zoom: zoom,
                pitch: 60,
                bearing: 0
            });

            const stores = document.querySelectorAll('.sg-store-infor__items');
            const storeArray = Array.from(stores).map((element) => {
                return {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [Number(element.dataset?.lng), Number(element.dataset?.lat)]
                    },
                    properties: {
                        phone:   element.dataset.phone,
                        address: element.dataset.address,
                        name:    element.dataset.name,
                        info:    element.querySelector('.store-infor__information')?.innerHTML || ''
                    }
                };
            });

            const listStore = {
                type: 'FeatureCollection',
                features: storeArray
            };

            listStore.features.forEach((store, index) => {
                store.properties.id = `sg_store_${index}`;
            });

            sgMap.on('load', () => {
                sgMap.addSource('sg-places', {
                    type: 'geojson',
                    data: listStore
                });
            });

            sgMap.addControl(
                new MapboxGeocoder({
                    accessToken: mapboxgl.accessToken,
                    mapboxgl: mapboxgl
                }),
                'top-left'
            );

            this.addMarker(listStore);
            this.storeInforAction(listStore);
        },

        addMarker: function (listStore) {
            listStore.features.forEach(store => {
                const marker = document.createElement('div');
                marker.id = `sg-marker-${store.properties.id}`;
                marker.addEventListener('click', () => {
                    this.createPopupMarker(store);
                    this.zoomMarker(store);
                });
                marker.classList.add('marker');
                new mapboxgl.Marker(marker, { offset: [0, -23] })
                    .setLngLat(store.geometry.coordinates)
                    .addTo(sgMap);
            });
        },

        createPopupMarker: function (store) {
            const closePopup = document.getElementsByClassName('mapboxgl-popup');
            if (closePopup[0]) closePopup[0].remove();

            const { name, info } = store.properties;
            new mapboxgl.Popup({ closeOnClick: false })
                .setLngLat(store.geometry.coordinates)
                .setHTML(`<h3>${name}</h3><div>${info}</div>`)
                .addTo(sgMap);

            let closeButton = document.querySelector('.bls__location-page .mapboxgl-popup-close-button');
            if (closeButton) {
                closeButton.innerHTML = `<svg width="13" height="13" viewBox="0 0 13 13" fill="white" class="transition"><use href="#icon-close" /></svg>`;
            }
        },

        zoomMarker: function (store) {
            sgMap.flyTo({
                center: store.geometry.coordinates,
                zoom: 15
            });
        },

        storeInforAction: function (listStore) {
            const listStoresInfor = document.querySelectorAll('.sg-store-infor__items');
            listStoresInfor.forEach(item => {
                item.addEventListener('click', e => {
                    e.preventDefault();
                    const index = parseInt(item.dataset.index, 10);

                    // Toggle active state
                    if (!item.classList.contains('store-active')) {
                        document.querySelectorAll('.sg-store-infor__items').forEach(el => {
                            el.classList.remove('store-active');
                        });
                        item.classList.add('store-active');
                    } else {
                        item.classList.remove('store-active');
                    }

                    const currentFeature = listStore.features[index];
                    if (currentFeature) {
                        this.createPopupMarker(currentFeature);
                        this.zoomMarker(currentFeature);
                    }
                });
            });
        }
    };
})();

SgCreateMapStoreLocation.init();
